import React, { useState } from 'react';
import { updatePassword } from '../components/DbServices';
import { getStoredUser, encryptData } from '../utilities/encryption'; // Import encryptData
import CryptoJS from "crypto-js";
import Swal from 'sweetalert2';

export default function SecuritySettings() {
  const [passwords, setPasswords] = useState({ old: '', new: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const [showPasswords, setShowPasswords] = useState(false);
  
  // Get user data from local storage
  const userSession = getStoredUser(); // This should be the decrypted object
  const userData = userSession?.data;
  const userId = userData?.id;
  
  // The stored password is likely an SHA256 hash if it came from Login/Reset
  const storedPasswordHash = userData?.password; 

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 1. Hash the "old" password input to compare with stored hash
    const oldPasswordHash = CryptoJS.SHA256(passwords.old).toString();
    debugger

    if (oldPasswordHash !== storedPasswordHash) {
        Swal.fire("Error", "The current password you entered is incorrect.", "error");
        return;
    }

    // 2. Validation
    if (passwords.new.length < 8) {
        Swal.fire("Error", "New password must be at least 8 characters.", "error");
        return;
    }

    if (passwords.new !== passwords.confirm) {
        Swal.fire("Error", "New passwords do not match!", "error");
        return;
    }

    if (passwords.new === passwords.old) {
        Swal.fire("Error", "New password cannot be the same as the old password.", "error");
        return;
    }
    
    setLoading(true);
    try {
      // Hash the new password for the API call
      const newPasswordHash = CryptoJS.SHA256(passwords.new).toString();
      
      const payload = {
        oldPassword: oldPasswordHash,
        newPassword: newPasswordHash
      };

      const res = await updatePassword(userId, payload);
      
      if (res.status === 200) {
        // 3. Update local storage using your encryption utility
        const updatedSession = { ...userSession };
        updatedSession.data.password = newPasswordHash;
        
        // Re-encrypt the whole object before storing
        const encryptedUser = encryptData(updatedSession);
        localStorage.setItem('user', encryptedUser);

        await Swal.fire("Success", "Password updated successfully!", "success");
        setPasswords({ old: '', new: '', confirm: '' });
      } else {
        Swal.fire("Error", res.message || "Failed to update password", "error");
      }
    } catch (err) {
      Swal.fire("Error", err.message || "An error occurred.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-1">
      <h5 className="fw-black mb-1" style={{ letterSpacing: '-0.5px' }}>Security & Password</h5>
      <p className="text-muted small mb-4">Protect your account with a strong encrypted password.</p>
      
      <form onSubmit={handleSubmit} style={{ maxWidth: '400px' }}>
        <div className="mb-3">
          <label className="form-label small fw-black text-muted tracking-wider">CURRENT PASSWORD</label>
          <input 
            type={showPasswords ? "text" : "password"} 
            className="form-control bg-light border-light-subtle py-2 rounded-3 shadow-none" 
            required 
            value={passwords.old}
            onChange={(e) => setPasswords({...passwords, old: e.target.value})}
            placeholder="••••••••"
            style={{ fontSize: '14px' }}
          />
        </div>

        <hr className="my-4 opacity-25" />

        <div className="mb-3">
          <label className="form-label small fw-black text-muted tracking-wider">NEW PASSWORD</label>
          <input 
            type={showPasswords ? "text" : "password"} 
            className="form-control bg-light border-light-subtle py-2 rounded-3 shadow-none" 
            required 
            value={passwords.new}
            onChange={(e) => setPasswords({...passwords, new: e.target.value})}
            placeholder="Min. 8 characters"
            style={{ fontSize: '14px' }}
          />
        </div>

        <div className="mb-3">
          <label className="form-label small fw-black text-muted tracking-wider">CONFIRM NEW PASSWORD</label>
          <input 
            type={showPasswords ? "text" : "password"} 
            className="form-control bg-light border-light-subtle py-2 rounded-3 shadow-none" 
            required 
            value={passwords.confirm}
            onChange={(e) => setPasswords({...passwords, confirm: e.target.value})}
            placeholder="Repeat new password"
            style={{ fontSize: '14px' }}
          />
        </div>

        <div className="form-check mb-4">
          <input 
            className="form-check-input" 
            type="checkbox" 
            id="showCheck" 
            onChange={() => setShowPasswords(!showPasswords)} 
          />
          <label className="form-check-label small text-muted fw-bold" htmlFor="showCheck">
            Show Passwords
          </label>
        </div>

        <button 
          className="btn py-2 px-4 rounded-pill fw-black text-white shadow-sm border-0 transition-all hover-lift" 
          style={{ background: 'linear-gradient(135deg, #6D28D9 0%, #06B6D4 100%)' }}
          disabled={loading}
        >
          {loading ? (
            <span className="spinner-border spinner-border-sm me-2"></span>
          ) : (
            <i className="fas fa-shield-alt me-2 small"></i>
          )}
          {loading ? 'SAVING...' : 'UPDATE PASSWORD'}
        </button>
      </form>

      <style>{`
        .fw-black { font-weight: 900 !important; }
        .tracking-wider { letter-spacing: 0.05rem; font-size: 11px; }
        .hover-lift:hover { transform: translateY(-1px); filter: brightness(1.1); }
      `}</style>
    </div>
  );
}